import { render, staticRenderFns } from "./TenantQuotas.vue?vue&type=template&id=3307516a&scoped=true"
import script from "./TenantQuotas.vue?vue&type=script&lang=js"
export * from "./TenantQuotas.vue?vue&type=script&lang=js"
import style0 from "./TenantQuotas.vue?vue&type=style&index=0&id=3307516a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307516a",
  null
  
)

export default component.exports